import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { OwnerSelectors, ApplicationState } from '../reducers';
import { OwnerActions } from '../core/actions';
import { Owner } from '../../objects/owner';
import { ServiceArea } from '../../objects/service-area';
import { BaseActionService } from './base.action.service';
import { Storefront } from './storefront.service';
import { DestinationSelectSetting } from '../../objects/destination-select-setting';

export interface IOwnerActionService {
  loadOwner(): void;
  getOwner(): Observable<Owner | null>;
  getServiceAreas(): Observable<ServiceArea[] | null>;
  getStorefront(): Observable<Storefront | null>;
  getStorefrontOrOwnerOrServiceAreasError(): Observable<Error | null>;
  getStorefrontError(): Observable<Error | null>;
  getDestinationSelectSetting(): Observable<DestinationSelectSetting>;
}

@Injectable({
  providedIn: 'root'
})
export class OwnerActionService
  extends BaseActionService<ApplicationState>
  implements IOwnerActionService {
  protected store: Store<ApplicationState>;


  constructor() {
    const store = inject<Store<ApplicationState>>(Store);

    super(store);

    this.store = store;
  }

  readonly owner = this.selectSignal(OwnerSelectors.getOwner);
  readonly serviceAreas = this.selectSignal(OwnerSelectors.getServiceAreas);
  readonly storefront = this.selectSignal(OwnerSelectors.getStorefront);
  readonly storefrontOrOwnerOrServiceAreasError = this.selectSignal(OwnerSelectors.getStorefrontOrOwnerOrServiceAreasError);
  readonly storefrontError = this.selectSignal(OwnerSelectors.getStorefrontError);
  readonly destinationSelectSetting = this.selectSignal(OwnerSelectors.getDestinationSelectSetting);

  getDestinationSelectSetting(): Observable<DestinationSelectSetting> {
    return super.get(OwnerSelectors.getDestinationSelectSetting);
  }

  loadOwner(): void {
    super.load(OwnerActions.loadOwner());
  }

  getOwner(): Observable<Owner | null> {
    return super.get(OwnerSelectors.getOwner);
  }

  getServiceAreas(): Observable<ServiceArea[] | null> {
    return super.get(OwnerSelectors.getServiceAreas);
  }

  getStorefrontOrOwnerOrServiceAreasError(): Observable<Error | null> {
    return super.get(OwnerSelectors.getStorefrontOrOwnerOrServiceAreasError);
  }

  getStorefront(): Observable<Storefront | null> {
    return super.get(OwnerSelectors.getStorefront);
  }

  getStorefrontError(): Observable<Error | null> {
    return super.get(OwnerSelectors.getStorefrontError);
  }
}
